import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@api/manage';
import { queryUserTreeList } from '@/api/api';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import SelectAssetModal from "../../../assets/SelectAssetModal";
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal1';
var columnsItem = [{
  title: '设备名称',
  dataIndex: 'equipmentId',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'equipmentId'
  }
}, {
  title: '产品名称',
  dataIndex: 'spareId',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'spareId'
  }
}, {
  title: '更换数量',
  dataIndex: 'num',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'num'
  }
}, {
  title: '更换原因',
  dataIndex: 'reason',
  width: '10%',
  align: 'center',
  scopedSlots: {
    customRender: 'reason'
  }
}, {
  title: '更换原因',
  dataIndex: 'reasonText',
  width: '10%',
  align: 'center',
  scopedSlots: {
    customRender: 'reasonText'
  }
}, {
  title: '是否为关键部位',
  align: 'center',
  dataIndex: 'important',
  width: '15%',
  scopedSlots: {
    customRender: 'important'
  }
}, {
  title: '更换周期',
  align: 'center',
  dataIndex: 'cycle',
  width: '15%',
  scopedSlots: {
    customRender: 'cycle'
  }
}, {
  title: '更换周期',
  align: 'center',
  dataIndex: 'cycleUnit',
  width: '15%',
  scopedSlots: {
    customRender: 'cycleUnit'
  }
}, {
  title: '备注',
  dataIndex: 'remark',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '操作',
  align: 'center',
  width: '15%',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataTable = [];
var dataItem = [];
var addItemDataIndex = 0;
export default {
  name: 'PartsReplacementModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    SelectAssetModal: SelectAssetModal,
    SelectAssetChemicalModal: SelectAssetChemicalModal
  },
  data: function data() {
    return {
      title: '备耗更换表单',
      tableName: 'om_parts_replacement',
      form_fields: ['siteId', 'userId', 'remark', 'tenantId'],
      form_fields_time: ['replaceDate'],
      userTree: [],
      equipmentOptions: [],
      codeDict: 'equipmentId,spareId',
      tabsKey: '1',
      showUpload: false,
      current: 0,
      tablePageIndex: 1,
      dataItem: [],
      tableData: [],
      productPartsIds: [],
      selectedProductParts: [],
      columnsItem: columnsItem,
      addItemDataIndex: addItemDataIndex,
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入站点id!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入运维人员!'
          }]
        },
        replaceDate: {
          rules: [{
            required: true,
            message: '请输入更换时间!'
          }]
        }
      },
      url: {
        // querySiteDevice: '/om/chemical/replace/querySiteDevice/',
        querySiteDevice: '/ea/asset/equipment',
        queryProductAssets: '/om/chemical/replace/queryProductAssets/',
        queryChemicalReplaceItem: '/om/chemical/replace/item/',
        deletePartsReplacementItem: '/om/parts/replacement/item/'
      },
      visiblepProduct: false,
      bodyStyle: {
        width: '1000px',
        height: 'auto'
      },
      columns: [{
        title: '名称',
        dataIndex: 'title',
        width: '300px',
        align: 'center'
      }, {
        title: '值',
        dataIndex: 'value',
        align: 'center',
        width: '300px',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        title: '附件',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      selectedRowKeysTable: [],
      selectedRowsTable: [],
      targetName: '',
      tableKey: ''
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    getData: function getData(value, e) {
      value['value'] = e;
    },
    getStatus: function getStatus(value, e) {
      value['value'] = e;
    },
    getUnit: function getUnit(value, e) {
      value['value'] = e;
    },
    getCycle: function getCycle(value, e) {
      value['value'] = e;
    },
    getNumUnit: function getNumUnit(index, e) {
      this.tableData[index].numUnit = e;
    },
    selectAssets: function selectAssets(record, index, index1) {
      this.current = index1;
      this.selectedRecord = record;
      this.$refs.AssetListModal.siteId = this.currentSiteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(record.productName, record.equipmentId);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      console.log('productList', productList);
      var selectedAsset = [];
      var assetIds = [];

      for (var i = 0; i < productList.length; i++) {
        selectedAsset.push(productList[i].productName);
        assetIds = productList[i].id;
      }

      this.selectedRecord.value = selectedAsset;
      this.selectedRecord.equipmentId = assetIds;
      console.log(this.selectedRecord);
      this.$forceUpdate(); // this.selectedAsset = []
      // this.assetIds = []
      // for (var i = 0; i < productList.length; i++) {
      // 	this.selectedAsset.push(productList[i].productName)
      // 	this.assetIds = productList[i].id
      // }
    },
    moment: moment,
    onSelectChange: function onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysTable = selectedRowKeys;
      this.selectedRowsTable = selectedRows;
      console.log("selectedRowKeys: ".concat(selectedRowKeys), 'selectedRows: ', selectedRows);
    },
    add: function add(siteId) {
      this.dataItem = [];
      this.tableData = [];
      if (undefined == siteId) this.$message.warning('请选择单个站点');
      this.edit({
        siteId: siteId
      });
    },
    edit: function edit(record) {
      var _this = this;

      this.tabsKey = '1';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadTreeList(this.model.siteId);
      this.model.siteName = this.siteName;
      this.visible = true; // this.visible1 = false

      this.selectedRowKeys = [];
      this.selectionRows = [];

      if (undefined == this.model.id) {
        this.dataItem = [];
        this.tableData = [];
        this.model.userId = this.$store.getters.userInfo.id;
        this.model.replaceDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      } else {
        this.getTableItem();
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    getTableItem: function getTableItem() {
      var _this2 = this;

      var partsReplaceItem = [];
      getAction('/om/parts/replacement/item/' + this.model.id).then(function (res) {
        var arr = [];
        var arr3 = [];
        partsReplaceItem = res.result;
        partsReplaceItem.forEach(function (item) {
          var data = {
            id: item.id,
            sumAmount: item.sumAmount,
            equipmentId: item.equipmentId,
            equipmentName: item.deviceName,
            spareId: item.spareId,
            companyName: item.companyName,
            cycle: item.cycle,
            cycleUnit: item.cycleUnit,
            important: item.important,
            num: item.num,
            numUnit: item.numUnit,
            model: item.model,
            reason: item.reason,
            reasonText: item.reasonText,
            remark: item.remark,
            editable: true
          };
          var arr1 = [];
          var arr2 = [];

          _this2.columnsItem.forEach(function (item1, index) {
            if (index < _this2.columnsItem.length - 1) {
              var tableData = {
                title: item1.title,
                code: item1.dataIndex,
                value: data[item1.dataIndex]
              };

              if (tableData.code == 'equipmentId') {
                tableData.value = data.equipmentName;
                tableData.equipmentId = data.equipmentId;
              }

              if (tableData.code == 'spareId') {
                tableData.value = data.companyName;
                tableData.spareId = data.spareId;
              }

              if (tableData.code == 'num') {
                tableData.sumAmount = data.sumAmount;
              }

              if (_this2.codeDict.indexOf(tableData.code) > -1) {
                tableData.fileSrc = "om_parts_replacement_item_".concat(tableData.code);
                tableData.srcId = item.id;
              }

              arr1.push(tableData);
              arr2.push(tableData);
              arr2.id = item.id;
              arr2.productName = item.productName;
              arr2.spareId = item.spareId;
              arr2.numUnit = item.numUnit;
            }
          });

          arr.push(arr1);
          arr3.push(arr2);
        });
        _this2.dataItem = arr;
        _this2.tableData = arr3;
        console.log("dataItem:", _this2.dataItem);
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.replaceDate = formData.replaceDate ? formData.replaceDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          var tableData = [];
          that.dataItem.forEach(function (item, index) {
            var obj = {};
            var sysFileList = [];
            var fileDelList = [];
            item.forEach(function (item1, index1) {
              obj[item1.code] = item1.value;

              if (item1.hasOwnProperty("equipmentId")) {
                obj.equipmentId = item1.equipmentId;
              }

              if (item1.sysFileList) {
                sysFileList = sysFileList.concat(item1.sysFileList);
                fileDelList = fileDelList.concat(item1.fileDelList);
              }
            });
            obj.sysFileList = sysFileList;
            obj.fileDelList = fileDelList;
            obj['spareId'] = _this3.tableData[index].spareId;
            obj['numUnit'] = _this3.tableData[index].numUnit;
            obj['id'] = _this3.tableData[index].id;
            tableData.push(obj);
          });
          formData.partsReplacementItemList = tableData;
          console.log("tableData:", tableData);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          console.log('formData', formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this3.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadTreeList: function loadTreeList(params) {
      var that = this;
      that.userTree = [];
      that.equipmentOptions = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      }); // // 站点设备
      // getAction(this.url.querySiteDevice,{siteId: params}).then(res => {
      //   if (res.success) {
      //     that.equipmentOptions = res.result
      //   }
      // })
    },
    addTable: function addTable() {
      var _this4 = this;

      var newData = _toConsumableArray(this.tableData);

      newData.push({
        equipmentId: '',
        spareId: '',
        num: '',
        reason: '',
        important: '',
        remark: '',
        editable: true
      });
      this.tableData = newData;
      var dataObj = {
        equipmentId: '',
        spareId: '',
        num: '',
        reason: '',
        important: '',
        remark: '',
        editable: true
      };
      var arr = [];
      this.columnsItem.forEach(function (item, index) {
        if (index < _this4.columnsItem.length - 1) {
          var tableData = {
            title: item.title,
            code: item.dataIndex,
            value: null
          };

          if (_this4.codeDict.indexOf(tableData.code) > -1) {
            tableData.fileSrc = "om_parts_replacement_item_".concat(tableData.code);
            tableData.srcId = null;
          }

          arr.push(tableData);
        }
      });
      this.dataItem.push(arr);
      this.tablePageIndex = this.dataItem.length;
    },
    handleChangeTable: function handleChangeTable(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }

      this.$forceUpdate();
    },
    handleChangeRestriction: function handleChangeRestriction(value, key, column) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0]; // const target1 = newData.filter(item => key != item.key)[0]

      if (target) {
        target[column] = value;
        this.dataItem = newData;
      }
    },
    delTable: function delTable(key) {
      var newData = this.dataItem.filter(function (item) {
        return key != item.key;
      });
      this.dataItem = newData;
      this.cacheItemData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
      console.log('this.dataItem', this.dataItem);
      this.$forceUpdate();
    },
    editTable: function editTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target.editable = true;
        this.dataItem = newData;
      }
    },
    saveTable: function saveTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        delete target.editable;
        this.dataItem = newData;
        this.cacheItemData = newData.map(function (item) {
          return _objectSpread({}, item);
        });
      }
    },
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        Object.assign(target, this.cacheItemData.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.dataItem = newData;
      }
    },
    selectProductParts: function selectProductParts(index1) {
      this.tableKey = index1;
      this.$refs.ProductPartsModal.category = 92;
      this.$refs.ProductPartsModal.disableSubmit = true;
      this.$refs.ProductPartsModal.add(this.selectedProductParts, this.productPartsIds);
    },
    choseProductParts: function choseProductParts(productList) {
      var _this5 = this;

      console.log(productList[0]);
      this.tableData.forEach(function (e, index) {
        if (index === _this5.tableKey) {
          e.spareId = productList[0].id;
          e.productName = productList[0].name + '(' + productList[0].unit_dictText + ')';
        }
      });
      this.$forceUpdate();
      console.log(this.tableData);
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      console.log(id);
      if (this.dataItem.length <= 0) return;

      if (id) {
        httpAction(this.url.deletePartsReplacementItem + '?id=' + id, '', 'DELETE').then(function (res) {
          if (res.success) {
            _this6.$notification.success({
              message: res.message
            });

            _this6.tableData.splice(_this6.tablePageIndex - 1, 1);

            _this6.dataItem.splice(_this6.tablePageIndex - 1, 1);
          } else {
            _this6.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
      }

      if (this.dataItem.length > 1 && this.tablePageIndex > 1) {
        this.tablePageIndex--;
      } else {
        this.tablePageIndex = 1;
      }
    },
    changeUpload: function changeUpload(e, record) {
      e.sysFileList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      e.fileDelList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      console.log('e,record', e, record);
      record.sysFileList = e.sysFileList;
      record.fileDelList = e.fileDelList;
      console.log('this', this.tableData);
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    }
  }
};